// Logos white-label (versão para fundo claro) por trecho do domínio.
// Fonte única usada pelo cabeçalho das consultas (HeaderQuery) e pelo
// "Salvar PDF" — o PDF é renderizado no painel principal em headless, onde o
// domínio do cliente não existe, então o caminho da logo precisa ser enviado
// por quem dispara o download.
const PDF_LOGOS_BY_HOST = [
  ["avaliecreditoconsultas", "/assets/white-label/avalie-credito/logo.png"],
  ["acessopositivo", "/assets/white-label/acesso-positivo/logo-azul.png"],
  ["proconsultbr", "/assets/white-label/pro-consult-br/logo_consult.png"],
  ["simscore", "/assets/white-label/sim-pesquisa/logo_sim.png"],
  ["simpesquisa", "/assets/white-label/sim-pesquisa/logo_sim.png"],
  ["credoresbrasil", "/assets/white-label/credores-brasil/logo.png"],
  ["consultaspositivo", "/assets/white-label/consultas-positivo/logo.png"],
  ["raioxconsultas", "/assets/white-label/raio-x/logo.png"],
  ["obahcredito", "/assets/white-label/obah-credito/logo.png"],
  ["hellusconsultoria", "/assets/white-label/hellus-consultoria/logo.png"],
  ["nomenoazul", "/assets/white-label/nome-no-azul/logo.png"],
  ["finposcore", "/assets/white-label/finpo-score/logo.png"],
  ["locagora", "/assets/white-label/locagora/logo.png"],
  ["riscocred", "/assets/white-label/riscocred/logo.png"],
  ["ampliacapital", "/assets/white-label/amplia-capital/logo.png"],
  ["periciadecredito", "/assets/white-label/pericia-de-credito/logo.png"],
  ["meuraioxdecredito", "/assets/white-label/raiox-de-credito/logo.png"],
  ["solucoesmoura", "/assets/white-label/solucoes-moura/logo.png"],
  ["restricar", "/assets/white-label/restricar/logo.png"],
];

export const DEFAULT_PDF_LOGO = "/assets/relinq_1.png";

// Domínios cujo produto é exclusivamente consulta veicular: têm login próprio,
// o menu não expõe crédito/cadastral e os atalhos apontam para /queries/autos.
const VEHICLE_ONLY_HOSTS = ["restricar"];

export const isVehicleOnlyHost = (
  href = typeof window !== "undefined" ? window.location.href : "",
) => VEHICLE_ONLY_HOSTS.some((token) => href.includes(token));

// Regras que valem só para a Restricar (ex.: o modal de crédito sugere o valor
// exato das consultas que ela vende, em vez das sugestões genéricas).
export const isRestricarHost = (
  href = typeof window !== "undefined" ? window.location.href : "",
) => href.includes("restricar");

// Temas de cor por domínio. O valor vira `data-white-label` no <html> e é o
// gancho dos blocos em styles/white-label-*.css — sem ele o sistema fica no
// tema padrão (azul).
const THEMES_BY_HOST = [["restricar", "restricar"]];

export const applyWhiteLabelTheme = (
  href = typeof window !== "undefined" ? window.location.href : "",
) => {
  if (typeof document === "undefined") return null;
  const match = THEMES_BY_HOST.find(([token]) => href.includes(token));
  if (!match) return null;
  document.documentElement.setAttribute("data-white-label", match[1]);
  return match[1];
};

export const getPdfLogoPath = (
  href = typeof window !== "undefined" ? window.location.href : "",
) => {
  const match = PDF_LOGOS_BY_HOST.find(([token]) => href.includes(token));
  return match ? match[1] : DEFAULT_PDF_LOGO;
};
